import { fetchLanguages } from './asyncThunk';
import { getListSlice, initialListState } from '../getListSlice';
import { IListState } from '../types';
import { ILanguage } from '../../../api/base/Languages/types';

export type ILanguagesState = IListState<ILanguage>;

const initialState: ILanguagesState = { ...initialListState };

const languagesSlice = getListSlice({
  moduleName: 'languages',
  fetchDataThunk: fetchLanguages,
  initialState,
});

export const languagesReducer = languagesSlice.reducer;
